import {observer} from 'mobx-react';
import {withState} from 'shared/core';
import {Layout} from 'shared/components';
import {TimeTrackingSubnav} from 'main/containers/time_tracking';
import ScheduleDirectory from './ScheduleDirectory';
import {SchedulesContainerState} from '../state';

const SchedulesContainer = observer(({scope, uiState}) => {
  return (
    <div>
      <TimeTrackingSubnav scope={scope}/>
      <Layout>
        <ScheduleDirectory uiState={uiState}/>
      </Layout>
    </div>
  );
});

export default withState(SchedulesContainer, SchedulesContainerState);
